import { render, staticRenderFns } from "./ResponseATRCDetailTable.vue?vue&type=template&id=5a9c1f9f"
import script from "./ResponseATRCDetailTable.vue?vue&type=script&lang=js"
export * from "./ResponseATRCDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ResponseATRCDetailTable.vue?vue&type=style&index=0&id=5a9c1f9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports